import "./NoticePage.css";
import { useParams } from "react-router";
import { useState, useEffect } from "react";
import { fetchNoticeData } from "../../../fetchFromDB";
import TextBubble from "../../TextBubble/TextBubble";
import ExternalLink from "../../ExternalLink/ExternalLink";

export default function NoticePage(props) {
    const { id } = useParams();
    const [data, setData] = useState([]);

    useEffect(() => {
        const loadData = async () => {
            try {
                const fetchedData = await fetchNoticeData(id);
                setData(fetchedData);
            } catch (error) {
                console.error("Failed to load events", error);
            }
        };
        loadData();
    }, [id]);

    return (
        <div className="notice-page">
            {data || data !== null ? (
                <>
                    <div className="notice-page-image-wrapper">
                        <img src={data.banner_src === null ? data.thumbnail_src : data.banner_src} alt={data.title} />
                    </div>
                    <h1>{data.title}</h1>
                    <div id="grey-information-text">
                        <p>{data.date}</p>
                    </div>
                    <br />
                    <p>{data.description_brief}</p>
                    <br />
                    <p>{data.body_text}</p>
                    {data.button_link !== "" && data.button_link !== null ? 
                    <>
                        <br />
                        <TextBubble>
                            <ExternalLink buttonType="wide" href={data.button_link}>
                                {data.button_text}
                            </ExternalLink>
                        </TextBubble>
                    </>
                    : null }
                </>
            )
            : <p>Loading...</p>}
        </div>
    )
}